import { Immutable } from "immer";
import React from "react";
import { RawHTMLBlock } from "tsi-common-react/src/components/RawHTMLBlock/index";

import type {
    PromoCopyContent,
    RawHTMLBlock as RawHTMLBlockValue,
    RichTextBlock as RichTextBlockValue,
} from "@reactivated";

import { StreamField } from "@thelabnyc/thelabui/src/components/StreamField";

const RICH_TEXT_WRAP_START = '<div class="rich-text">';
const RICH_TEXT_WRAP_END = "</div>";

export type PromoCopyValue = Immutable<PromoCopyContent>;

const unwrapRichTextBlock = (value: string): string =>
    value.startsWith(RICH_TEXT_WRAP_START) && value.endsWith(RICH_TEXT_WRAP_END)
        ? value.slice(RICH_TEXT_WRAP_START.length, -RICH_TEXT_WRAP_END.length)
        : value;

const RichTextPromoBlock = (
    block: Immutable<{ value: RichTextBlockValue }>,
): React.JSX.Element => (
    <div
        className="rich-text"
        dangerouslySetInnerHTML={{
            __html: unwrapRichTextBlock(block.value),
        }}
    />
);

const RawHTMLPromoBlock = (
    block: Immutable<{ value: RawHTMLBlockValue }>,
): React.JSX.Element => <RawHTMLBlock value={block.value} />;

const promoCopyComponentsMap = {
    rich_text: RichTextPromoBlock,
    html_block: RawHTMLPromoBlock,
} as const;

export const PromoCopyStreamField = (props: {
    value: PromoCopyValue;
}): React.JSX.Element => (
    <>
        {props.value.map((block) => (
            <StreamField
                key={block.id}
                tagName="div"
                attrs={{
                    className: `w-block-${block.type} block-${block.type}`,
                }}
                value={[block]}
                components={promoCopyComponentsMap}
            />
        ))}
    </>
);
